module.exports = __webpack_public_path__ + "img/login-bottom.10639e23.png";